<ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
<div id="fl-main-showcase-container" [class.virtual-mode]="isVirtualMode">
    <!-- Left Panel - Only visible in virtual mode on desktop -->
    <div class="virtual-left-panel d-none d-lg-flex" *ngIf="isVirtualMode">
        <div class="virtual-left-content">
            <a style="margin-bottom:5px;" href="https://www.producthunt.com/products/flinkit?utm_source=badge-top-post-badge&amp;utm_medium=badge#flinkit-friends" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=291287&amp;theme=light&amp;period=daily" alt="Flinkit Friends | Product Hunt" style="width: 220px; height: 54px; margin-bottom:5px;" width="250" height="54"></a>
            <h4 id="flinkit-outdoor-tite" style="font-weight: bold;" class="mt-3">{{ leftPanelCopy.title }}</h4>

  <p>{{ leftPanelCopy.tagline }}</p>

  <p class="mt-3">{{ leftPanelCopy.description }}</p>

            <div class="virtual-game-mode-selector">
                <label class="virtual-label">Game Mode:</label>
                <div class="fi-segmented-control gray">
                    <button 
                        class="fi-text-bold" 
                        (click)="setGameMode('outdoor')" 
                        [class.active]="selectedGameMode === 'outdoor'">
                        Outdoor
                    </button>
                    <button 
                        class="fi-text-bold" 
                        (click)="setGameMode('indoor')" 
                        [class.active]="selectedGameMode === 'indoor'">
                        Indoor
                    </button>
                    <button 
                        class="fi-text-bold" 
                        (click)="setGameMode('event-hall')" 
                        [class.active]="selectedGameMode === 'event-hall'">
                        Event Hall
                    </button>
                </div>
            </div>
            <a href="https://calendly.com/flinkitwebinar/30min" target="_blank" class="flinkint-btn outline no-link btn-block mt-3 animated-btn"><span>Schedule a call</span></a>
            <a href="https://admin.flinkit.io/register" target="_blank" class="flinkint-btn outline no-link btn-block mt-1 mb-3 animated-btn"><span>Register</span></a>
        </div>
    </div>

    <!-- Center - Phone Container -->
    <div>
        <div id="content-showcase-container">
            <div id="inner-showcase-container">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>

    <!-- Right Panel - Only visible in virtual mode on desktop -->
    <div class="virtual-right-panel d-none d-lg-flex" *ngIf="isVirtualMode">
        <div class="virtual-right-content">
            <div class="text-center" style="font-size: 13px;">
                Trusted by some of the best teams.
            </div>
            <div class="virtual-logos-container mt-3">
                <div class="virtual-logo-item" *ngFor="let logo of virtualLogos">
                    <img [src]="logo" alt="Partner Logo" class="virtual-logo-img">
                </div>
            </div>
        </div>
    </div>
</div>